import {
  Box,
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import {
  CircleSmallLogo,
  HelpIcon,
  ManualsIcon,
  PoweredByLogo,
  TermsLogo,
  PrivacyLogo,
} from "../assets/Sidebar";
import { useState } from "react";
import { useAppSelector } from "../../../Redux/hooks";

const VersionDetails = () => (
  <Box sx={{ px: 2, pt: 2, pb: 0.5 }}>
    <Divider />
    <Typography
      variant="body1"
      fontWeight={"medium"}
      color="gray"
      fontSize={12}
      sx={{ textAlign: "center", mt: 2 }}
    >
      Version 5.0.8 (09/06/2025)
    </Typography>
  </Box>
);

const VersionWrapper = ({ participant }: any) => {
  const collapsed = useAppSelector((state) => state.app.collapsed);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const openMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  const navigateToLink = (type: string) => {
    setAnchorEl(null);
    if (type === "terms") {
      window.open("https://www.mahalo.health/privacy-policy", "_blank");
    } else {
      window.open("https://mahalo.gitbook.io/mahalo-docs", "_blank");
    }
  };

  return (
    <Box>
      <Divider />
      <Box className="sider-menu" onClick={openMenu}>
        <HelpIcon />
        {!collapsed && (
          <Typography variant="subtitle1" ml={1}>
            Help
          </Typography>
        )}
      </Box>
      {!collapsed && (
        <>
          <Divider />
          <Box
            sx={{
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              mt: 2,
              ml: 2,
            }}
          >
            {participant ? <CircleSmallLogo /> : <PoweredByLogo />}
            <Typography variant="body1" fontWeight={"medium"} color="gray">
              Powered by Mahalo
            </Typography>
          </Box>
        </>
      )}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={closeMenu}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        PaperProps={{
          sx: {
            mt: -1.5,
          },
        }}
      >
        <MenuItem onClick={() => navigateToLink("terms")}>
          <ListItemIcon>
            <PrivacyLogo />
          </ListItemIcon>
          <ListItemText sx={{ color: "#6B7280" }}>Privacy Policy</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => navigateToLink("terms")}>
          <ListItemIcon>
            <TermsLogo />
          </ListItemIcon>
          <ListItemText sx={{ color: "#6B7280" }}>Terms of Use</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => navigateToLink("manuals")}>
          <ListItemIcon>
            <ManualsIcon />
          </ListItemIcon>
          <ListItemText sx={{ color: "#6B7280" }}>Manuals</ListItemText>
        </MenuItem>
        <VersionDetails />
      </Menu>
    </Box>
  );
};

export default VersionWrapper;
